/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Component } from '@angular/core';

// TODO: Improve a11y with better text appropriate to usage (example: loading cart spinner)

@Component({
  selector: 'cx-spinner',
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  constructor() {
    // Intentional empty constructor
  }
}
